module.exports = __webpack_public_path__ + "img/8.a2414d5f.jpg";